export default __webpack_public_path__ + "static/media/natalie.8a96201e.png";